module.exports = __webpack_public_path__ + "static/media/visa_card.3d83ff5a.jpg";